import { useGetIdentity } from "ra-core";
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router";
import { TaskCalendar } from "./TaskCalendar";
import { TaskWorkDialog } from "./TaskWorkDialog";
import { useStore } from "ra-core";
import { validDate } from "./installation";
import type { CalendarScale } from "./calendarModel";
import { format } from "date-fns";

const CalendarPage = () => {
  const [params, setParams] = useSearchParams();
  const linkedTask = params.get("task");
  const [, setDate] = useStore(
    "calendar.date.v2",
    format(new Date(), "yyyy-MM-dd"),
  );
  const [, setScale] = useStore<CalendarScale>("calendar.scale.v2", "month");
  useEffect(() => {
    const date = params.get("date"),
      view = params.get("view");
    if (!date || !validDate(date)) return;
    setDate(date);
    if (view === "year" || view === "month" || view === "day") setScale(view);
    const next = new URLSearchParams(params);
    next.delete("date");
    next.delete("view");
    setParams(next, { replace: true });
  }, [params, setParams, setDate, setScale]);
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    const header = document.querySelector(".rovero-header");
    if (!header) return;
    const measure = () =>
      ref.current?.style.setProperty(
        "--calendar-top-offset",
        `${ref.current?.getBoundingClientRect().top ?? header.getBoundingClientRect().height}px`,
      );
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    measure();
    return () => observer.disconnect();
  }, []);
  return (
    <section ref={ref} className="crm-calendar-shell" aria-label="Календарь">
      <TaskCalendar />
      {linkedTask && /^\d+$/.test(linkedTask) && (
        <TaskWorkDialog
          open
          taskId={linkedTask}
          onOpenChange={(open) => {
            if (!open) {
              const next = new URLSearchParams(params);
              next.delete("task");
              setParams(next, { replace: true });
            }
          }}
        />
      )}
    </section>
  );
};

export const TasksPage = () => {
  const { identity } = useGetIdentity();
  return identity ? <CalendarPage /> : null;
};
